export interface User {
  Role: string;
  Email: string;
  WWID: string;
}

export const users: User[] = [
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "alejandro.polanco@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "saurabh.malhan@cummins.com",
    "WWID": "kz858@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "hr.desk@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "rohan.siddheshwar@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "jordan.nussear@cummins.com",
    "WWID": "tw666@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "luke.dewey@cummins.com",
    "WWID": "fg654@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "shridhar.badagi@cummins.com",
    "WWID": "fx071@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "gaurav.madhok@cummins.com",
    "WWID": "hw117@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "mugatrao.indalkar@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "ankit.singh.2@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "dipika9.paul@simadvisorypartner.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "Ila.chauhan@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "sherlock.liu@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "gary.beshears@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "urja.shah@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "eric.hood@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "ashwini.retarekar@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "lisa.a.notestein@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "sukru.harsa@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "shanila.s.bhatty@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "atsushi.miyashita@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "xinwen.gao@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "prasanth.reddy@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "souvik.ghosh@simadvisorypartner.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "chetan.rc@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "meenu.yadav@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "ameya.khandekar@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "emily.a.scheuerell@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "jeffrey.wiltrout@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "aki.bentley@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "xinwen.gao@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "somdatt.sharma@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "gajanan.n.joshi@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "hubert.rojas-rodriguez@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "baffour.yeboah@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "daniel.robinson@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "joshua.dahms@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "james.keane@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "babu.ekambaram@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "tobenna.maduka@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "shruthi.r@simadvisory.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "aaditya.bhardwaj@simadvisory.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "niki.thomas@simadvisorypartner.com",
     "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "gayathri.ashok@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "eugenia.stutz@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "praveen.kumar@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "anil.kataria@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "brian.t.olson@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "bharath.vn@simadvisorypartner.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "vivek.maurya@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "monika.dhongade@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "vandana.fullara@simadvisorytech.com",
    "WWID": ""
  },
   {
    "Role": "g_CPHM_phi_admin",
    "Email": "anu.johny@simadvisorypartner.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "harshwardhan.ratnaparkhi@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "mounika.keerti@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "deepak.kumar@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "keerti.mounika@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "sridhar.mathaiah@simadvisorypartner.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "m.srinivas@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "raviraj.meena@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "anand.kumar3@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "scott.a.files@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "pallavi.sonker@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "edmonds.brown@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "carlos.ortega@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "chengcheng.gong@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "nebil.awad.baqhum@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "mariam.topuria@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "chuka.adibuah@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "rahul.balakrishnan@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "smita.debnath@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "venkatesh.tanguturi@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "virginia.veruette-maya@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "cameron.briggs@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "brian.m.smith@cummins.com",
    "WWID": ""
  },
   {
    "Role": "g_CPHM_phi_general_user",
    "Email":"vinay.sai@simadvisorytech.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "chirag.puri@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_admin",
    "Email": "okechi.igwebuike@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "regina.barringer@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "robert.schaefer@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "vani.narayanan@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "allen.meek@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "andreas.dammann@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "carlos.gasteazoro@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "ginger.lirette@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "seth.berry@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "terrence.q.taylor@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "leigha.chadwell@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "guilherme.colloca@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "andrew.g.stiles@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "ross.kunkler@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "shannon.kiely-heider@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "maleah.hamilton@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "rich.s.wagner@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "aaron.n.schilling@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "gang.huang@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "damian.mcgowan@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "yanming.ma@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "katie.suhre@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "elizabeth.creaney@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "brenda.hardesty@cummins.com",
    "WWID": ""
  },
    {
    "Role": "g_CPHM_phi_general_user",
    "Email": "andrea.grossman@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "carson.littrell@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "jorge.arguelles@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "abiola.abioye.yusuff@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "serlinna.kuet@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "alexander.a.marino@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "jiabo.zhang@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "miranda.cross@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "tony.lee@cummins.com",
    "WWID": "bk067@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "ioana.i.capelo@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "richard.newman@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "b.fu@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "dave.rehse@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "mustafa.aytin@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "sarah.j.bilston@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "wee.ming.ku@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "eugene.chan@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "ralf.mueller@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "sean.lynas@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "alberto.gradara@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "dimitrij.fauser@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "piotr.jacewicz@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "sedad.hadzic@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "kerstin.herz@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "takahiro.yamakawa@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "yukiko.kitaura@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "shane.shi@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "raymond.yin@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "branda.zhou@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "simon.leng@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "jiangang.liu@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "roland.yu@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "Rong.Wang@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "wang.jiuchun@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "manish.k.singh@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "pawan.chadha@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "girish.uttamchandani@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "prashant.b.kumar@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_product_managers",
    "Email": "nagaswetha.ts@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "m.srinivas@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "justin.d.blomenberg@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "ryan.e.edgecomb@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "adam.k.snyder@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "russell.lile@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "dylan.sequeira@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "Wesley.a.Loxley@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "michelle.matlock@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "clay.a.coons@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "bill.a.pearce@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "amit.kumar@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "armin.henrich@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "cary.a.mcfarden@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "charles.applewhite@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "han.tian.chue@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "jonathan.meinhardt@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "norman.brown.ruiz@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "pablo.a.palacios.torres@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "peter.schmitt@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "Steven.Baxter@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "david.j.bugert@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "daniel.merz@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "graham.e.rudd@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "kelle.ravn@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "hidemasa.takasugi@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "Harshavardan.Tripathi@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "paul.j.wright@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "james.moeller@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "kyle.roshak@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "pooja.pushkarna@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "abhishek.mehrotra@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "tushar.takawale@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "madhav.bhosale@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "gaurav.chavan@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "li.jiang@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "alona.pehrson@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "john.e.echavarria@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "frank.ruggiero@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "haytham.giha@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "dave.l.hirt@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "laura.k.chrisman@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "timothy.mantsch@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "jacob.saewert@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "tom.s.mcgibbon@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "brian.neumann@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "michael.coxen@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "benjamin.c.henry@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "tim.worme@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "brian.yoon@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "anita.yang@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "Samuel.Jones@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "kenichi.inai@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "stephen.j.cummins@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "andriyanto.andriyanto@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "david.abbott@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "stewart.mckeddie@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "ben.clark@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "jason.p.linke@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "john.tickle@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "teejay.momoh@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "olusola.afolabi@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "brian.breaux@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "michael.r.aufdermauer@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "tomislav.t.budija@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "nicholas.kryder@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "justin.harkness@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "tom.lamano@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "richard.dorf@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "sylvain.godbout@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "johnny.mulfati@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "cory.w.abel@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "benjamin.schilling@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "barry.r.warn@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "chris.m.mcgough@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "pete.maingi@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "brian.pinkstaff@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "greg.totin@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "randy.washer@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "justin.harkness@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "ruimin.chai@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "amol.damle@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "amy.l.fischvogt@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "valerie.wedgeworth@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "roberto.arellano@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "phanindra.garimella@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "junaid.husain@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "kate.corney@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "ahmad.s.adam@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "gbile.adewunmi@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "abhishek.damani@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "ayda.ogden@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "molly.puga@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "marcos.martinez@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "hernan.anzola@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "donia.jose@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "preetam.ganguly@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "bhanu.chandar.sriram@cummins.com",
    "WWID": ""
  },
  {
    "Role": "g_CPHM_phi_general_user",
    "Email": "jeffrey.wiltrout@cummins.com",
    "WWID": ""
  },
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "eric.j.young@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "curtis.liu@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "bryce.tiller@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "praveena.jetty@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "evan.hill@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "andrew.laughlin@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "david.j.vanvalkenburg@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "joshua.phipps@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "t.fan@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "stephan.cannell@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "diego.congote@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "zhang.j@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "parimal.saparia@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_general_user",
  "Email": "pablo.corrales@cummins.com",
  "WWID": ""
},
{
  "Role": "g_CPHM_phi_product_managers",
  "Email": "audra.henderson@cummins.com",
  "WWID": ""
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "vivek.malapati@cummins.com",
    "WWID": ""
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "suchitha.subramanian@cummins.com",
    "WWID": ""
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "diogo.gernhardt@cummins.com",
    "WWID": ""
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "karthick.rajan@cummins.com",
    "WWID": ""
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "eric.ribbeck@cummins.com",
    "WWID": ""
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "ratnesh.patil@cummins.com",
    "WWID": "lc589@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "rajendra.gund@cummins.com",
    "WWID": "fz554@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "jonathan.mehringer@cummins.com",
    "WWID": "td337@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "jameson.smith@cummins.com",
    "WWID": "jx768@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "rex.e.ralston@cummins.com",
    "WWID": "as348@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "suzannah.miller@cummins.com",
    "WWID": "pd726@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "rohit.n.patil@cummins.com",
    "WWID": "mr841@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "todd.m.andresen@cummins.com",
    "WWID": "fc473@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "deepak.pillai@cummins.com",
    "WWID": "ie128@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "kathryn.mccarthy@cummins.com",
    "WWID": "ls181@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "peter.horton@cummins.com",
    "WWID": "mo038@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "sophie.hayles@cummins.com",
    "WWID": "fe451@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "joao.r.moretto@cummins.com",
    "WWID": "dj399@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "oliver.tann@cummins.com",
    "WWID": "fh424@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "raghavender.neradi@cummins.com",
    "WWID": "jv897@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "jonathan.mehringer@cummins.com",
    "WWID": "td337@cummins.com"
},
{
    "Role": "g_CPHM_phi_general_user",
    "Email": "renee.e.wilson@cummins.com",
    "WWID": "bd267@cummins.com"
},
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "goran.galic@cummins.com",
    "WWID": "nq564@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "mehdi.tibri@cummins.com",
    "WWID": "ku027@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "akunor.n.azu@cummins.com",
    "WWID": "cq005@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "camille.hatchett@cummins.com",
    "WWID": "cj609@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "Christopher.J.Brown@cummins.com",
    "WWID": "jm452@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "chris.heffernan@cummins.com",
    "WWID": "if262@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "kristy.green@cummins.com",
    "WWID": "jo573@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "nikola.kastel@cummins.com",
    "WWID": "nx928@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "stefan.wezenbeek@cummins.com",
    "WWID": "ul617@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "chernise.naicker@cummins.com",
    "WWID": "op556@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "seraphin.kalala@cummins.com",
    "WWID": "mq796@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "jaouad.ezzarhouni@cummins.com",
    "WWID": "ks427@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "rhea.harripersadh@cummins.com",
    "WWID": "oo236@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "chris.hoch@cummins.com",
    "WWID": "rw905@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "justin.han@cummins.com",
    "WWID": "kg658@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "alexei.khovaev@cummins.com",
    "WWID": "jq152@cummins.com"
  },
  {
    "Role": "g_CPHM_phi_surveyonly_user",
    "Email": "shawn.a.rockey@cummins.com",
    "WWID": "bl916@cummins.com"
  }
];
